import { render, staticRenderFns } from "./question_template.vue?vue&type=template&id=768539e6&scoped=true"
import script from "./question_template.vue?vue&type=script&lang=js"
export * from "./question_template.vue?vue&type=script&lang=js"
import style0 from "./question_template.vue?vue&type=style&index=0&id=768539e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768539e6",
  null
  
)

export default component.exports